import { ProductDetailsDtoKind } from '@models';

export const getProductImage = (type: ProductDetailsDtoKind) => {
  return `/${type.toLowerCase()}-logo.png`;
};
